@if (controlMode === "game-only") {
  @if (!orchestration.activeController()) {
    <div class="loading">
      <app-loading-spinner></app-loading-spinner>
    </div>
  }

  <div class="padding container">
    @if (orchestration.gameInterfaceState() === GameInterfaceState.GameStarting) {
      <div class="starting">
        <app-loading-spinner></app-loading-spinner>
      </div>
    }

    @if (orchestration.activeController(); as controller) {
      <app-game-screen class="game-screen" [gameController]="controller" tabindex="0">
      </app-game-screen>
    }
  </div>
}

@if (controlMode === "full") {
  <div class="footer-content center-children" [class.tier-first-ux]="isTierFirstActive()">
    <div class="footer-background" [class.has-content]="showingControls()">
      <ng-container #gameControls></ng-container>
    </div>
  </div>
}
